var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"display":"block"},attrs:{"alt":_vm.alt,"height":_vm.height,"src":require(`@/assets/logos/principal/${_vm.client}.png`),"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }